// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: int_flight.proto

/* eslint-disable */
import { SearchSource, searchSourceFromJSON, searchSourceToJSON } from "./common_enum";
import {
  BackButtonSource,
  backButtonSourceFromJSON,
  backButtonSourceToJSON,
  CabinType,
  cabinTypeFromJSON,
  cabinTypeToJSON,
  FieldError,
  SortingOption,
  sortingOptionFromJSON,
  sortingOptionToJSON,
  TripType,
  tripTypeFromJSON,
  tripTypeToJSON,
} from "./flights_enum";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "usertracking.v3";

export interface IntFlight {
  departure_date: Date | undefined;
  arrival_date: Date | undefined;
  cabin_type: CabinType;
  origin_city: string;
  destination_city: string;
  origin_is_city: boolean;
  destination_is_city: boolean;
  search_calendar_type: string;
  trip_type: TripType;
  number_of_passengers: number;
  route: string;
  search_source: SearchSource;
  search_window: number;
  user_segment_name: string[];
  has_filters_on: boolean;
  position_rank: number;
  return_departure_date: Date | undefined;
  return_arrival_date: Date | undefined;
  origin_airport: string;
  destination_airport: string;
  payment_created_source: string;
  number_of_prev_orders: number;
  number_of_results: number;
  has_cip_selected: boolean;
  has_free_cab_selected: boolean;
  payment_gateway: string;
  stock: string;
  system_name: string;
  eligible_payment_gateways: string[];
  has_guideline_clicked: boolean;
  banner_image_link: string;
  filters: string[];
  has_price_alert_set: boolean;
  number_of_field_errors: number;
  errors: string[];
  back_button_header: boolean;
  gateway: string;
  is_price_table_best_price: boolean;
  filter_field: string;
  leg: string;
  is_best_flight: boolean;
  sorting_option: SortingOption;
  back_button_source: BackButtonSource;
  email_autofill: boolean;
  type_errors: FieldError[];
  badge_lists: string[];
  trip_purpose: string;
  is_price_calendar_best_price: boolean;
  destination_country: string;
  origin_country: string;
  ua: string;
  discount_amount: number;
  inbound_airline_code: string;
  inbound_airline_name: string;
  outbound_airline_code: string;
  outbound_airline_name: string;
  total_price: number;
  adult_count: number;
  child_count: number;
  infant_count: number;
  utm_medium: string;
  utm_source: string;
  source: string;
  channel: string;
  discount_code: string;
  is_snapppay_eligible: boolean;
  search_started: number;
  results_rendered: number;
  search_response_received: number;
  backend_latency: number;
  frontend_rendering_time: number;
  total_wait_time: number;
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
  origin_rank: number;
  destination_rank: number;
}

function createBaseIntFlight(): IntFlight {
  return {
    departure_date: undefined,
    arrival_date: undefined,
    cabin_type: CabinType.economy,
    origin_city: "",
    destination_city: "",
    origin_is_city: false,
    destination_is_city: false,
    search_calendar_type: "",
    trip_type: TripType.one_way,
    number_of_passengers: 0,
    route: "",
    search_source: SearchSource.search_box,
    search_window: 0,
    user_segment_name: [],
    has_filters_on: false,
    position_rank: 0,
    return_departure_date: undefined,
    return_arrival_date: undefined,
    origin_airport: "",
    destination_airport: "",
    payment_created_source: "",
    number_of_prev_orders: 0,
    number_of_results: 0,
    has_cip_selected: false,
    has_free_cab_selected: false,
    payment_gateway: "",
    stock: "",
    system_name: "",
    eligible_payment_gateways: [],
    has_guideline_clicked: false,
    banner_image_link: "",
    filters: [],
    has_price_alert_set: false,
    number_of_field_errors: 0,
    errors: [],
    back_button_header: false,
    gateway: "",
    is_price_table_best_price: false,
    filter_field: "",
    leg: "",
    is_best_flight: false,
    sorting_option: SortingOption.best,
    back_button_source: BackButtonSource.header,
    email_autofill: false,
    type_errors: [],
    badge_lists: [],
    trip_purpose: "",
    is_price_calendar_best_price: false,
    destination_country: "",
    origin_country: "",
    ua: "",
    discount_amount: 0,
    inbound_airline_code: "",
    inbound_airline_name: "",
    outbound_airline_code: "",
    outbound_airline_name: "",
    total_price: 0,
    adult_count: 0,
    child_count: 0,
    infant_count: 0,
    utm_medium: "",
    utm_source: "",
    source: "",
    channel: "",
    discount_code: "",
    is_snapppay_eligible: false,
    search_started: 0,
    results_rendered: 0,
    search_response_received: 0,
    backend_latency: 0,
    frontend_rendering_time: 0,
    total_wait_time: 0,
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
    origin_rank: 0,
    destination_rank: 0,
  };
}

export const IntFlight: MessageFns<IntFlight> = {
  fromJSON(object: any): IntFlight {
    return {
      departure_date: isSet(object.departure_date) ? fromJsonTimestamp(object.departure_date) : undefined,
      arrival_date: isSet(object.arrival_date) ? fromJsonTimestamp(object.arrival_date) : undefined,
      cabin_type: isSet(object.cabin_type) ? cabinTypeFromJSON(object.cabin_type) : CabinType.economy,
      origin_city: isSet(object.origin_city) ? globalThis.String(object.origin_city) : "",
      destination_city: isSet(object.destination_city) ? globalThis.String(object.destination_city) : "",
      origin_is_city: isSet(object.origin_is_city) ? globalThis.Boolean(object.origin_is_city) : false,
      destination_is_city: isSet(object.destination_is_city) ? globalThis.Boolean(object.destination_is_city) : false,
      search_calendar_type: isSet(object.search_calendar_type) ? globalThis.String(object.search_calendar_type) : "",
      trip_type: isSet(object.trip_type) ? tripTypeFromJSON(object.trip_type) : TripType.one_way,
      number_of_passengers: isSet(object.number_of_passengers) ? globalThis.Number(object.number_of_passengers) : 0,
      route: isSet(object.route) ? globalThis.String(object.route) : "",
      search_source: isSet(object.search_source) ? searchSourceFromJSON(object.search_source) : SearchSource.search_box,
      search_window: isSet(object.search_window) ? globalThis.Number(object.search_window) : 0,
      user_segment_name: globalThis.Array.isArray(object?.user_segment_name)
        ? object.user_segment_name.map((e: any) => globalThis.String(e))
        : [],
      has_filters_on: isSet(object.has_filters_on) ? globalThis.Boolean(object.has_filters_on) : false,
      position_rank: isSet(object.position_rank) ? globalThis.Number(object.position_rank) : 0,
      return_departure_date: isSet(object.return_departure_date)
        ? fromJsonTimestamp(object.return_departure_date)
        : undefined,
      return_arrival_date: isSet(object.return_arrival_date)
        ? fromJsonTimestamp(object.return_arrival_date)
        : undefined,
      origin_airport: isSet(object.origin_airport) ? globalThis.String(object.origin_airport) : "",
      destination_airport: isSet(object.destination_airport) ? globalThis.String(object.destination_airport) : "",
      payment_created_source: isSet(object.payment_created_source)
        ? globalThis.String(object.payment_created_source)
        : "",
      number_of_prev_orders: isSet(object.number_of_prev_orders) ? globalThis.Number(object.number_of_prev_orders) : 0,
      number_of_results: isSet(object.number_of_results) ? globalThis.Number(object.number_of_results) : 0,
      has_cip_selected: isSet(object.has_cip_selected) ? globalThis.Boolean(object.has_cip_selected) : false,
      has_free_cab_selected: isSet(object.has_free_cab_selected)
        ? globalThis.Boolean(object.has_free_cab_selected)
        : false,
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      stock: isSet(object.stock) ? globalThis.String(object.stock) : "",
      system_name: isSet(object.system_name) ? globalThis.String(object.system_name) : "",
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      has_guideline_clicked: isSet(object.has_guideline_clicked)
        ? globalThis.Boolean(object.has_guideline_clicked)
        : false,
      banner_image_link: isSet(object.banner_image_link) ? globalThis.String(object.banner_image_link) : "",
      filters: globalThis.Array.isArray(object?.filters)
        ? object.filters.map((e: any) => globalThis.String(e))
        : [],
      has_price_alert_set: isSet(object.has_price_alert_set) ? globalThis.Boolean(object.has_price_alert_set) : false,
      number_of_field_errors: isSet(object.number_of_field_errors)
        ? globalThis.Number(object.number_of_field_errors)
        : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
      back_button_header: isSet(object.back_button_header) ? globalThis.Boolean(object.back_button_header) : false,
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      is_price_table_best_price: isSet(object.is_price_table_best_price)
        ? globalThis.Boolean(object.is_price_table_best_price)
        : false,
      filter_field: isSet(object.filter_field) ? globalThis.String(object.filter_field) : "",
      leg: isSet(object.leg) ? globalThis.String(object.leg) : "",
      is_best_flight: isSet(object.is_best_flight) ? globalThis.Boolean(object.is_best_flight) : false,
      sorting_option: isSet(object.sorting_option) ? sortingOptionFromJSON(object.sorting_option) : SortingOption.best,
      back_button_source: isSet(object.back_button_source)
        ? backButtonSourceFromJSON(object.back_button_source)
        : BackButtonSource.header,
      email_autofill: isSet(object.email_autofill) ? globalThis.Boolean(object.email_autofill) : false,
      type_errors: globalThis.Array.isArray(object?.type_errors)
        ? object.type_errors.map((e: any) => FieldError.fromJSON(e))
        : [],
      badge_lists: globalThis.Array.isArray(object?.badge_lists)
        ? object.badge_lists.map((e: any) => globalThis.String(e))
        : [],
      trip_purpose: isSet(object.trip_purpose) ? globalThis.String(object.trip_purpose) : "",
      is_price_calendar_best_price: isSet(object.is_price_calendar_best_price)
        ? globalThis.Boolean(object.is_price_calendar_best_price)
        : false,
      destination_country: isSet(object.destination_country) ? globalThis.String(object.destination_country) : "",
      origin_country: isSet(object.origin_country) ? globalThis.String(object.origin_country) : "",
      ua: isSet(object.ua) ? globalThis.String(object.ua) : "",
      discount_amount: isSet(object.discount_amount) ? globalThis.Number(object.discount_amount) : 0,
      inbound_airline_code: isSet(object.inbound_airline_code) ? globalThis.String(object.inbound_airline_code) : "",
      inbound_airline_name: isSet(object.inbound_airline_name) ? globalThis.String(object.inbound_airline_name) : "",
      outbound_airline_code: isSet(object.outbound_airline_code) ? globalThis.String(object.outbound_airline_code) : "",
      outbound_airline_name: isSet(object.outbound_airline_name) ? globalThis.String(object.outbound_airline_name) : "",
      total_price: isSet(object.total_price) ? globalThis.Number(object.total_price) : 0,
      adult_count: isSet(object.adult_count) ? globalThis.Number(object.adult_count) : 0,
      child_count: isSet(object.child_count) ? globalThis.Number(object.child_count) : 0,
      infant_count: isSet(object.infant_count) ? globalThis.Number(object.infant_count) : 0,
      utm_medium: isSet(object.utm_medium) ? globalThis.String(object.utm_medium) : "",
      utm_source: isSet(object.utm_source) ? globalThis.String(object.utm_source) : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      channel: isSet(object.channel) ? globalThis.String(object.channel) : "",
      discount_code: isSet(object.discount_code) ? globalThis.String(object.discount_code) : "",
      is_snapppay_eligible: isSet(object.is_snapppay_eligible)
        ? globalThis.Boolean(object.is_snapppay_eligible)
        : false,
      search_started: isSet(object.search_started) ? globalThis.Number(object.search_started) : 0,
      results_rendered: isSet(object.results_rendered) ? globalThis.Number(object.results_rendered) : 0,
      search_response_received: isSet(object.search_response_received)
        ? globalThis.Number(object.search_response_received)
        : 0,
      backend_latency: isSet(object.backend_latency) ? globalThis.Number(object.backend_latency) : 0,
      frontend_rendering_time: isSet(object.frontend_rendering_time)
        ? globalThis.Number(object.frontend_rendering_time)
        : 0,
      total_wait_time: isSet(object.total_wait_time) ? globalThis.Number(object.total_wait_time) : 0,
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
      origin_rank: isSet(object.origin_rank) ? globalThis.Number(object.origin_rank) : 0,
      destination_rank: isSet(object.destination_rank) ? globalThis.Number(object.destination_rank) : 0,
    };
  },

  toJSON(message: IntFlight): unknown {
    const obj: any = {};
    if (message.departure_date !== undefined) {
      obj.departure_date = message.departure_date.toISOString();
    }
    if (message.arrival_date !== undefined) {
      obj.arrival_date = message.arrival_date.toISOString();
    }
    if (message.cabin_type !== CabinType.economy) {
      obj.cabin_type = cabinTypeToJSON(message.cabin_type);
    }
    if (message.origin_city !== "") {
      obj.origin_city = message.origin_city;
    }
    if (message.destination_city !== "") {
      obj.destination_city = message.destination_city;
    }
    if (message.origin_is_city !== false) {
      obj.origin_is_city = message.origin_is_city;
    }
    if (message.destination_is_city !== false) {
      obj.destination_is_city = message.destination_is_city;
    }
    if (message.search_calendar_type !== "") {
      obj.search_calendar_type = message.search_calendar_type;
    }
    if (message.trip_type !== TripType.one_way) {
      obj.trip_type = tripTypeToJSON(message.trip_type);
    }
    if (message.number_of_passengers !== 0) {
      obj.number_of_passengers = Math.round(message.number_of_passengers);
    }
    if (message.route !== "") {
      obj.route = message.route;
    }
    if (message.search_source !== SearchSource.search_box) {
      obj.search_source = searchSourceToJSON(message.search_source);
    }
    if (message.search_window !== 0) {
      obj.search_window = Math.round(message.search_window);
    }
    if (message.user_segment_name?.length) {
      obj.user_segment_name = message.user_segment_name;
    }
    if (message.has_filters_on !== false) {
      obj.has_filters_on = message.has_filters_on;
    }
    if (message.position_rank !== 0) {
      obj.position_rank = Math.round(message.position_rank);
    }
    if (message.return_departure_date !== undefined) {
      obj.return_departure_date = message.return_departure_date.toISOString();
    }
    if (message.return_arrival_date !== undefined) {
      obj.return_arrival_date = message.return_arrival_date.toISOString();
    }
    if (message.origin_airport !== "") {
      obj.origin_airport = message.origin_airport;
    }
    if (message.destination_airport !== "") {
      obj.destination_airport = message.destination_airport;
    }
    if (message.payment_created_source !== "") {
      obj.payment_created_source = message.payment_created_source;
    }
    if (message.number_of_prev_orders !== 0) {
      obj.number_of_prev_orders = Math.round(message.number_of_prev_orders);
    }
    if (message.number_of_results !== 0) {
      obj.number_of_results = Math.round(message.number_of_results);
    }
    if (message.has_cip_selected !== false) {
      obj.has_cip_selected = message.has_cip_selected;
    }
    if (message.has_free_cab_selected !== false) {
      obj.has_free_cab_selected = message.has_free_cab_selected;
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.stock !== "") {
      obj.stock = message.stock;
    }
    if (message.system_name !== "") {
      obj.system_name = message.system_name;
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.has_guideline_clicked !== false) {
      obj.has_guideline_clicked = message.has_guideline_clicked;
    }
    if (message.banner_image_link !== "") {
      obj.banner_image_link = message.banner_image_link;
    }
    if (message.filters?.length) {
      obj.filters = message.filters;
    }
    if (message.has_price_alert_set !== false) {
      obj.has_price_alert_set = message.has_price_alert_set;
    }
    if (message.number_of_field_errors !== 0) {
      obj.number_of_field_errors = Math.round(message.number_of_field_errors);
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    if (message.back_button_header !== false) {
      obj.back_button_header = message.back_button_header;
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.is_price_table_best_price !== false) {
      obj.is_price_table_best_price = message.is_price_table_best_price;
    }
    if (message.filter_field !== "") {
      obj.filter_field = message.filter_field;
    }
    if (message.leg !== "") {
      obj.leg = message.leg;
    }
    if (message.is_best_flight !== false) {
      obj.is_best_flight = message.is_best_flight;
    }
    if (message.sorting_option !== SortingOption.best) {
      obj.sorting_option = sortingOptionToJSON(message.sorting_option);
    }
    if (message.back_button_source !== BackButtonSource.header) {
      obj.back_button_source = backButtonSourceToJSON(message.back_button_source);
    }
    if (message.email_autofill !== false) {
      obj.email_autofill = message.email_autofill;
    }
    if (message.type_errors?.length) {
      obj.type_errors = message.type_errors.map((e) => FieldError.toJSON(e));
    }
    if (message.badge_lists?.length) {
      obj.badge_lists = message.badge_lists;
    }
    if (message.trip_purpose !== "") {
      obj.trip_purpose = message.trip_purpose;
    }
    if (message.is_price_calendar_best_price !== false) {
      obj.is_price_calendar_best_price = message.is_price_calendar_best_price;
    }
    if (message.destination_country !== "") {
      obj.destination_country = message.destination_country;
    }
    if (message.origin_country !== "") {
      obj.origin_country = message.origin_country;
    }
    if (message.ua !== "") {
      obj.ua = message.ua;
    }
    if (message.discount_amount !== 0) {
      obj.discount_amount = Math.round(message.discount_amount);
    }
    if (message.inbound_airline_code !== "") {
      obj.inbound_airline_code = message.inbound_airline_code;
    }
    if (message.inbound_airline_name !== "") {
      obj.inbound_airline_name = message.inbound_airline_name;
    }
    if (message.outbound_airline_code !== "") {
      obj.outbound_airline_code = message.outbound_airline_code;
    }
    if (message.outbound_airline_name !== "") {
      obj.outbound_airline_name = message.outbound_airline_name;
    }
    if (message.total_price !== 0) {
      obj.total_price = Math.round(message.total_price);
    }
    if (message.adult_count !== 0) {
      obj.adult_count = Math.round(message.adult_count);
    }
    if (message.child_count !== 0) {
      obj.child_count = Math.round(message.child_count);
    }
    if (message.infant_count !== 0) {
      obj.infant_count = Math.round(message.infant_count);
    }
    if (message.utm_medium !== "") {
      obj.utm_medium = message.utm_medium;
    }
    if (message.utm_source !== "") {
      obj.utm_source = message.utm_source;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.channel !== "") {
      obj.channel = message.channel;
    }
    if (message.discount_code !== "") {
      obj.discount_code = message.discount_code;
    }
    if (message.is_snapppay_eligible !== false) {
      obj.is_snapppay_eligible = message.is_snapppay_eligible;
    }
    if (message.search_started !== 0) {
      obj.search_started = Math.round(message.search_started);
    }
    if (message.results_rendered !== 0) {
      obj.results_rendered = Math.round(message.results_rendered);
    }
    if (message.search_response_received !== 0) {
      obj.search_response_received = Math.round(message.search_response_received);
    }
    if (message.backend_latency !== 0) {
      obj.backend_latency = Math.round(message.backend_latency);
    }
    if (message.frontend_rendering_time !== 0) {
      obj.frontend_rendering_time = Math.round(message.frontend_rendering_time);
    }
    if (message.total_wait_time !== 0) {
      obj.total_wait_time = Math.round(message.total_wait_time);
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    if (message.origin_rank !== 0) {
      obj.origin_rank = Math.round(message.origin_rank);
    }
    if (message.destination_rank !== 0) {
      obj.destination_rank = Math.round(message.destination_rank);
    }
    return obj;
  },

  create(base?: DeepPartial<IntFlight>): IntFlight {
    return IntFlight.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IntFlight>): IntFlight {
    const message = createBaseIntFlight();
    message.departure_date = object.departure_date ?? undefined;
    message.arrival_date = object.arrival_date ?? undefined;
    message.cabin_type = object.cabin_type ?? CabinType.economy;
    message.origin_city = object.origin_city ?? "";
    message.destination_city = object.destination_city ?? "";
    message.origin_is_city = object.origin_is_city ?? false;
    message.destination_is_city = object.destination_is_city ?? false;
    message.search_calendar_type = object.search_calendar_type ?? "";
    message.trip_type = object.trip_type ?? TripType.one_way;
    message.number_of_passengers = object.number_of_passengers ?? 0;
    message.route = object.route ?? "";
    message.search_source = object.search_source ?? SearchSource.search_box;
    message.search_window = object.search_window ?? 0;
    message.user_segment_name = object.user_segment_name?.map((e) => e) || [];
    message.has_filters_on = object.has_filters_on ?? false;
    message.position_rank = object.position_rank ?? 0;
    message.return_departure_date = object.return_departure_date ?? undefined;
    message.return_arrival_date = object.return_arrival_date ?? undefined;
    message.origin_airport = object.origin_airport ?? "";
    message.destination_airport = object.destination_airport ?? "";
    message.payment_created_source = object.payment_created_source ?? "";
    message.number_of_prev_orders = object.number_of_prev_orders ?? 0;
    message.number_of_results = object.number_of_results ?? 0;
    message.has_cip_selected = object.has_cip_selected ?? false;
    message.has_free_cab_selected = object.has_free_cab_selected ?? false;
    message.payment_gateway = object.payment_gateway ?? "";
    message.stock = object.stock ?? "";
    message.system_name = object.system_name ?? "";
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.has_guideline_clicked = object.has_guideline_clicked ?? false;
    message.banner_image_link = object.banner_image_link ?? "";
    message.filters = object.filters?.map((e) => e) || [];
    message.has_price_alert_set = object.has_price_alert_set ?? false;
    message.number_of_field_errors = object.number_of_field_errors ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    message.back_button_header = object.back_button_header ?? false;
    message.gateway = object.gateway ?? "";
    message.is_price_table_best_price = object.is_price_table_best_price ?? false;
    message.filter_field = object.filter_field ?? "";
    message.leg = object.leg ?? "";
    message.is_best_flight = object.is_best_flight ?? false;
    message.sorting_option = object.sorting_option ?? SortingOption.best;
    message.back_button_source = object.back_button_source ?? BackButtonSource.header;
    message.email_autofill = object.email_autofill ?? false;
    message.type_errors = object.type_errors?.map((e) => FieldError.fromPartial(e)) || [];
    message.badge_lists = object.badge_lists?.map((e) => e) || [];
    message.trip_purpose = object.trip_purpose ?? "";
    message.is_price_calendar_best_price = object.is_price_calendar_best_price ?? false;
    message.destination_country = object.destination_country ?? "";
    message.origin_country = object.origin_country ?? "";
    message.ua = object.ua ?? "";
    message.discount_amount = object.discount_amount ?? 0;
    message.inbound_airline_code = object.inbound_airline_code ?? "";
    message.inbound_airline_name = object.inbound_airline_name ?? "";
    message.outbound_airline_code = object.outbound_airline_code ?? "";
    message.outbound_airline_name = object.outbound_airline_name ?? "";
    message.total_price = object.total_price ?? 0;
    message.adult_count = object.adult_count ?? 0;
    message.child_count = object.child_count ?? 0;
    message.infant_count = object.infant_count ?? 0;
    message.utm_medium = object.utm_medium ?? "";
    message.utm_source = object.utm_source ?? "";
    message.source = object.source ?? "";
    message.channel = object.channel ?? "";
    message.discount_code = object.discount_code ?? "";
    message.is_snapppay_eligible = object.is_snapppay_eligible ?? false;
    message.search_started = object.search_started ?? 0;
    message.results_rendered = object.results_rendered ?? 0;
    message.search_response_received = object.search_response_received ?? 0;
    message.backend_latency = object.backend_latency ?? 0;
    message.frontend_rendering_time = object.frontend_rendering_time ?? 0;
    message.total_wait_time = object.total_wait_time ?? 0;
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    message.origin_rank = object.origin_rank ?? 0;
    message.destination_rank = object.destination_rank ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
